import {
    PERSIST_EXPANDED_ROUTES,
    PERSIST_SET_THEME_LIGHT,
    PERSIST_SET_EDIT_MODE,
    PERSIST_ROLE_ACTIVE_NAME,
    PERSIST_PAGE_ROLE_DEFAULT_VIEW,
    PERSIST_PORTFOLIO_DEFAULT_VIEW,
    PERSIST_SETTINGS_DRAWERS_OPEN,
    PERSIST_GANTT_EXPANDED_TASKIDS
} from "./persistTypes";

export const initialState = {
    // App
    expandedRoutes: [],
    themeLight: true,
    isEditing: false,

    // Current role being viewed in the role selector
    activeRoleName: null,

    // Flip States i.e. default or flip component
    flipStates: [],

    // Portfolio
    portfolioDefaultViewTable: false,

    // Settings Drawer
    settingsDrawersOpen: [],

    // GANTT
    expandedGanttTaskIDs: []
};

export default function persistReducer(state = initialState, action) {
    switch (action.type) {
        case PERSIST_EXPANDED_ROUTES: {
            return {
                ...state,
                expandedRoutes: action.payload
            }
        }
        case PERSIST_SET_THEME_LIGHT:
            return {
                ...state,
                themeLight: action.payload
            };
        case PERSIST_SET_EDIT_MODE:
            return {
                ...state,
                isEditing: action.payload
            };
        case PERSIST_ROLE_ACTIVE_NAME: {
            return {
                ...state,
                activeRoleName: action.payload
            }
        }
        case PERSIST_PAGE_ROLE_DEFAULT_VIEW: {
            return {
                ...state,
                flipStates: action.payload
            }
        }
        case PERSIST_PORTFOLIO_DEFAULT_VIEW: {
            return {
                ...state,
                portfolioDefaultViewTable: action.payload
            }
        }
        case PERSIST_SETTINGS_DRAWERS_OPEN: {
            return {
                ...state,
                settingsDrawersOpen: action.payload
            }
        }
        case PERSIST_GANTT_EXPANDED_TASKIDS: {
            return {
                ...state,
                expandedGanttTaskIDs: action.payload
            }
        }
        default:
            return state;
    }
};
